export default {
  "order-confirmation": () => import("/usr/src/app/layouts/OrderConfirmation.vue").then(m => m.default || m),
  "product-detail": () => import("/usr/src/app/layouts/ProductDetail.vue").then(m => m.default || m),
  checkout: () => import("/usr/src/app/layouts/checkout.vue").then(m => m.default || m),
  default: () => import("/usr/src/app/layouts/default.vue").then(m => m.default || m),
  error: () => import("/usr/src/app/layouts/error.vue").then(m => m.default || m),
  "product-list": () => import("/usr/src/app/layouts/productList.vue").then(m => m.default || m)
}